import View from '../../View'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import {defer} from '../../atUtils'
import {openEditTaskPanel} from '../task/editPanel/actions'
import {getOpenTaskId} from '../task/editPanel/selectors'
import {openProjectPanel} from '../project/actions'
import {getOpenProjectId} from '../project/selectors'
import {openCustomerPanel} from '../customer/actions'
import {getOpenCustomerId} from '../customer/selectors'
import {getIdFromQuery, getStringFromQuery, removeUrlParamFromQuery, replaceIdIntoQuery} from './utils'
import {CREATE_TASK_PAGE_ACTION, CUSTOMER_ID_QUERY_KEY, PAGE_ACTION_QUERY_KEY, PROJECT_ID_QUERY_KEY, TASK_ID_QUERY_KEY, TASK_NAME_QUERY_KEY} from './constants'
import {isPanelOpened} from '../task/createPanel/selectors'

export class UrlHelper extends View {
    constructor({
        openTaskPanel = (taskId) => {},
        openProjectPanel = (projectId) => {},
        openCustomerPanel = (customerId) => {},
        openCreateTaskPopup = () => {}
    }) {
        super(null)

        this.state = {
            taskId: null,
            projectId: null,
            customerId: null,
        }

        this.callbacks = {
            openCreateTaskPopup,
        }

        this.actions = {
            openTaskPanel,
            openProjectPanel,
            openCustomerPanel,
        }

        this.onStatePropertyChanged('taskId', this._createHandleOpenPanelIdChanged(TASK_ID_QUERY_KEY))

        this.onStatePropertyChanged('projectId', this._createHandleOpenPanelIdChanged(PROJECT_ID_QUERY_KEY))

        this.onStatePropertyChanged('customerId', this._createHandleOpenPanelIdChanged(CUSTOMER_ID_QUERY_KEY))
    }

    afterRender() {
        // get all ids from query
        // first priority for task id
        // second project id
        // third customer id
        const taskId = getIdFromQuery(TASK_ID_QUERY_KEY)
        const projectId = getIdFromQuery(PROJECT_ID_QUERY_KEY)
        const customerId = getIdFromQuery(CUSTOMER_ID_QUERY_KEY)
        const pageAction = getStringFromQuery(PAGE_ACTION_QUERY_KEY)
        const taskName = getStringFromQuery(TASK_NAME_QUERY_KEY)

        // check contains url page action and equals action to create task
        // If new actions appear on the page, you need to add more branches
        if(pageAction && pageAction === CREATE_TASK_PAGE_ACTION)
        {
            this._callOpenCreatePanelAction(this.callbacks.openCreateTaskPopup, taskName)
        }
        else
        {
            this._tryToOpenEntityPanel(taskId, projectId, customerId)
        }
    }

    _tryToOpenEntityPanel(taskId, projectId, customerId) {
        if (taskId !== null) {
            this._callOpenPanelAction(this.actions.openTaskPanel, taskId)
        } else if (projectId !== null) {
            this._callOpenPanelAction(this.actions.openProjectPanel, projectId)
        } else if (customerId !== null) {
            this._callOpenPanelAction(this.actions.openCustomerPanel, customerId)
        }
    }

    _callOpenPanelAction = (action, id) => {
        defer(() => action(id, true))
    }

    _callOpenCreatePanelAction = (action, taskName) => {
        defer(() => {
            action()
            removeUrlParamFromQuery(TASK_NAME_QUERY_KEY)
            removeUrlParamFromQuery(PAGE_ACTION_QUERY_KEY)
        })
    }

    _createHandleOpenPanelIdChanged = (queryKey) => {
        return (id, prevId) => {
            if (id !== null) {
                replaceIdIntoQuery(queryKey, id, prevId)
            } else if (prevId) {
                removeUrlParamFromQuery(queryKey)
            }
        }
    }
}

export default connect(
    (state) => ({
        taskId: getOpenTaskId(state),
        projectId: getOpenProjectId(state),
        customerId: getOpenCustomerId(state),
    }),
    (dispatch) => ({
        openTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
        openProjectPanel: bindActionCreators(openProjectPanel, dispatch),
        openCustomerPanel: bindActionCreators(openCustomerPanel, dispatch),
    })
)(UrlHelper)



// WEBPACK FOOTER //
// ./web/js/panels/urlHelper/index.js